import { z } from 'zod';
import type { MoneyJson } from '../money/money';
import { moneySchema } from './common.schemas';

export const approvalTierInputSchema = z.object({
  amount: moneySchema,
  roleKey: z.string().min(1).max(64),
});
export type ApprovalTierInput = z.infer<typeof approvalTierInputSchema>;

/** `PUT /approval-thresholds/:kind` — replaces the kind's whole ladder; an empty array means every amount falls to the Admin ceiling. */
export const updateApprovalTiersSchema = z.object({
  tiers: z.array(approvalTierInputSchema),
});
export type UpdateApprovalTiersInput = z.infer<typeof updateApprovalTiersSchema>;

export interface ApprovalTierView {
  amount: MoneyJson;
  roleKey: string;
}

/** One approval kind and its ladder, sorted ascending by amount — the admin screen's unit of display and edit. */
export interface ApprovalKindLadder {
  key: string;
  name: string;
  /** False until an admin saves a real edit — marks the seeded numbers as placeholders. */
  thresholdsConfirmed: boolean;
  tiers: ApprovalTierView[];
}
